import React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import ConditionMatcher from './ConditionMatcher';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import i18n from '../../i18n';
import { Condition } from '../../types/rest/dslTypes';

interface ConditionMatchersListProps {
  id: string;
  matcherList: Condition[] | null;
  matcherTitle: string;
  handleAddNew: () => void;
  onListChange: (list: Condition[]) => void;
  isReadOnly?: boolean;
  isWizardModal?: boolean;
  shorTitle?: boolean;
}

const colSizes: { md: ('auto' | number)[] } = {
  md: ['auto', 3, 3, 3, 2],
};

const ConditionMatchersList = (props: ConditionMatchersListProps) => {
  const { t } = useTranslation('transactions');

  const handleDelete = (index: number) => {
    if (props.matcherList) {
      const updated = _.cloneDeep(props.matcherList);
      updated.splice(index, 1);
      props.onListChange(updated);
    }
  };

  const handleChange = (fieldName: string, value: string, index) => {
    if (props.matcherList) {
      const list: Condition[] = _.cloneDeep(props.matcherList);
      if (index === -1) {
        console.log(`Cannot update value! Cannot find ${index} in the list.`);
      } else {
        list[index].matcher[fieldName] = value;
        props.onListChange(list);
      }
    }
  };

  const getComponentKey = (index: number) => {
    return 'condition-' + index;
  };

  return (
    <div id={'qa-' + props.id}>
      <p>{i18n.t('transactions:processingActions.modal.triggerCondition')}</p>

      {/* Header */}
      <Row>
        <Col md={colSizes.md[0]}>
          <strong style={{ visibility: 'hidden' }}>If</strong>
        </Col>
        <Col md={colSizes.md[1]}>
          <Form.Label>{t('editor.matcherExpression')}</Form.Label>
        </Col>
        <Col md={colSizes.md[2]}>
          <Form.Label>{t('editor.matcherOperatorShort')}</Form.Label>
        </Col>
        <Col md={colSizes.md[3]}>
          <Form.Label>{t('editor.matcherValue')}</Form.Label>
        </Col>
        <Col md={colSizes.md[4]}></Col>
      </Row>
      {/* ./ Header */}

      {props.matcherList.map((item: Condition, index: number) => (
        <ConditionMatcher
          onChange={(name, value) => handleChange(name, value, index)}
          onAdd={props.handleAddNew}
          onDelete={() => handleDelete(index)}
          displayAdd={index === length - 1}
          key={getComponentKey(index)}
          id={getComponentKey(index)}
          colSizes={colSizes}
          matcherValues={item.matcher}
          matcherTitle={props.matcherTitle}
          isReadOnly={props.isReadOnly}
          isWizardModal={props.isWizardModal}
          shortTitle={props.shorTitle}
          showAddIcon={index === _.size(props.matcherList) - 1}
        />
      ))}
    </div>
  );
};

export default ConditionMatchersList;
